import type { number, option } from '@code-expert/prelude';
import { tagged } from '@code-expert/prelude';

// -------------------------------------------------------------------------------------------------
// Types

/** No work has been done on this task */
type None = tagged.Tagged<'none'>;

/** The task has been submitted, but no definitive mark has been assigned */
type Pending = tagged.Tagged<'pending', option.Option<number.UnitInterval>>;

/** The task was marked but no attempt was found that passed */
type Failed = tagged.Tagged<'failed', number.UnitInterval>;

/** The task was completed successfully */
type Success = tagged.Tagged<'success', number.UnitInterval>;

/** The overall progress of a task, derived from exercise, task, and submissions */
export type TaskProgress = None | Pending | Failed | Success;

export const taskProgress = tagged.build<TaskProgress>();

// -------------------------------------------------------------------------------------------------
// Functions
